import * as React from 'react'
import { VariantProps, cva } from 'class-variance-authority'

export const $heading = cva('font-medium tracking-tighter', {
  variants: {
    size: {
      large: 'text-xl leading-[1.2] sm:text-2xl lg:text-2.5xl xl:text-3xl',
      regular: 'text-[20px] md:text-2xl leading-[1.2]',
      mini: 'text-[20px] md:text-xl leading-[1.2]',
      xs: 'text-lg leading-[22px]',
    },
  },
  defaultVariants: {
    size: 'regular',
  },
})

type HeadingUnion = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

type HeadingProps = React.JSX.IntrinsicElements[HeadingUnion] & {
  as: HeadingUnion
  unstyled?: boolean
} & VariantProps<typeof $heading>

export const Heading: React.FC<React.PropsWithChildren<HeadingProps>> = ({
  children,
  as: Comp,
  className,
  size,
  unstyled,
  ...rest
}) => {
  return (
    <Comp
      {...rest}
      className={unstyled ? className : $heading({ class: className, size })}
    >
      {children}
    </Comp>
  )
}
